export default {
    PARSE_ERROR: -32700,        // invalid json
    INVALID_REQUEST: -32600,    // invalid request
    METHOD_NOT_FOUND: -32601,   // missing handler
    INVALID_PARAMS: -32602,     // bad params
    INTERNAL_ERROR: -32603,     // we dun goof'd
    UNKNOWN_ID: -32604,         // ADDED -- received answer for unknown ID
    EXECUTION_ERROR: -32002,    // handler goof'd
};
